import React from "react";

export function ForumThread() {
  return (
    <div className="fqxi-shortcodes-forumThread"></div>
  );
}
